import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme'
import { CssBaseline } from '@mui/material'
import { RecoilRoot } from 'recoil'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Open Sans:400,600,700', 'sans-serif'],
  },
})

// workaround to fix warnings in console due to emotion bug
const cache = createCache({
  key: 'css',
  prepend: true,
})
cache.compat = true

ReactDOM.render(
  <React.StrictMode>
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RecoilRoot>
          <App />
        </RecoilRoot>
      </ThemeProvider>
    </CacheProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
